import cn from 'classnames'
import { FC } from 'react'
import { DotProps } from 'react-multi-carousel'
import Image from 'next/image'
import { emptyImagePlaceholder } from 'constants/image'
import s from './carousel.module.css'

const Thumbnail: FC<DotProps & { thumbnails: Array<string> }> = ({ thumbnails, index, active, ...rest }) => {
  return (
    <button type="button" className={cn(s.thumbnail, active && s.thumbnailIsActive)} {...rest}>
      <Image src={thumbnails[index as number] || emptyImagePlaceholder} width={80} height={80} alt="" />
    </button>
  )
}

export { Thumbnail }
